import React from "react";
import { Link, useLocation } from "react-router-dom";
import businessName from "../../assets/branding/heading.svg";

export default function Banner() {
    const location = useLocation();
    const isAuthRoute = ["/", "/entry", "/login", "/verify-code", "/auth-status", "/portal-selection"]
        .some((pathname) => location.pathname.startsWith(pathname));
    const isReferrerPortal = location.pathname.startsWith("/referrer");
    const logoTarget = isAuthRoute ? "/entry" : isReferrerPortal ? "/referrer/dashboard" : "/dashboard";

    return (
        <div className="w-full flex justify-center py-4">
            <Link to={logoTarget} aria-label="Financial Edge secure access home">
                <img
                    src={businessName}
                    alt="Financial Edge"
                    className="h-[80px] md:h-[100px] object-contain cursor-pointer"
                />
            </Link>
        </div>
    );
}
